// English football pyramid (2025/26 season) — Premier League down to National League North & South.
// Plus Scottish Premiership. Colours are each club's primary shirt/crest colour.
// Kept flat for simple search; grouped by tier via `league` for future filtering.
export const CLUBS = [
  // ---------- Premier League (2025/26) ----------
  { name: "Arsenal", league: "Premier League", color: "#EF0107" },
  { name: "Aston Villa", league: "Premier League", color: "#7A003C" },
  { name: "Bournemouth", league: "Premier League", color: "#DA291C" },
  { name: "Brentford", league: "Premier League", color: "#E30613" },
  { name: "Brighton & Hove Albion", league: "Premier League", color: "#0057B8" },
  { name: "Burnley", league: "Premier League", color: "#6C1D45" },
  { name: "Chelsea", league: "Premier League", color: "#034694" },
  { name: "Crystal Palace", league: "Premier League", color: "#1B458F" },
  { name: "Everton", league: "Premier League", color: "#003399" },
  { name: "Fulham", league: "Premier League", color: "#000000" },
  { name: "Leeds United", league: "Premier League", color: "#FFCD00" },
  { name: "Liverpool", league: "Premier League", color: "#C8102E" },
  { name: "Manchester City", league: "Premier League", color: "#6CABDD" },
  { name: "Manchester United", league: "Premier League", color: "#DA291C" },
  { name: "Newcastle United", league: "Premier League", color: "#241F20" },
  { name: "Nottingham Forest", league: "Premier League", color: "#DD0000" },
  { name: "Sunderland", league: "Premier League", color: "#EB172B" },
  { name: "Tottenham Hotspur", league: "Premier League", color: "#132257" },
  { name: "West Ham United", league: "Premier League", color: "#7A263A" },
  { name: "Wolverhampton Wanderers", league: "Premier League", color: "#FDB913" },

  // ---------- EFL Championship (2025/26) ----------
  { name: "Birmingham City", league: "Championship", color: "#0000B4" },
  { name: "Blackburn Rovers", league: "Championship", color: "#009EE0" },
  { name: "Bristol City", league: "Championship", color: "#B70000" },
  { name: "Cardiff City", league: "Championship", color: "#0070B5" },
  { name: "Charlton Athletic", league: "Championship", color: "#E31B23" },
  { name: "Coventry City", league: "Championship", color: "#87CEEB" },
  { name: "Derby County", league: "Championship", color: "#000000" },
  { name: "Hull City", league: "Championship", color: "#F18A01" },
  { name: "Ipswich Town", league: "Championship", color: "#3764A4" },
  { name: "Leicester City", league: "Championship", color: "#003090" },
  { name: "Middlesbrough", league: "Championship", color: "#E32017" },
  { name: "Millwall", league: "Championship", color: "#001B41" },
  { name: "Norwich City", league: "Championship", color: "#FFF200" },
  { name: "Oxford United", league: "Championship", color: "#F9DC00" },
  { name: "Portsmouth", league: "Championship", color: "#001489" },
  { name: "Preston North End", league: "Championship", color: "#00437B" },
  { name: "Queens Park Rangers", league: "Championship", color: "#1D5BA4" },
  { name: "Sheffield United", league: "Championship", color: "#EE2737" },
  { name: "Sheffield Wednesday", league: "Championship", color: "#4A90E2" },
  { name: "Southampton", league: "Championship", color: "#D71920" },
  { name: "Stoke City", league: "Championship", color: "#E03A3E" },
  { name: "Swansea City", league: "Championship", color: "#121212" },
  { name: "Watford", league: "Championship", color: "#FBEE23" },
  { name: "West Bromwich Albion", league: "Championship", color: "#122F67" },
  { name: "Wrexham", league: "Championship", color: "#E4022D" },

  // ---------- EFL League One (2025/26) ----------
  { name: "AFC Wimbledon", league: "League One", color: "#1F3F97" },
  { name: "Barnsley", league: "League One", color: "#E20E0E" },
  { name: "Blackpool", league: "League One", color: "#F68712" },
  { name: "Bolton Wanderers", league: "League One", color: "#263C7E" },
  { name: "Bradford City", league: "League One", color: "#800000" },
  { name: "Burton Albion", league: "League One", color: "#FFD700" },
  { name: "Doncaster Rovers", league: "League One", color: "#DA291C" },
  { name: "Exeter City", league: "League One", color: "#DA291C" },
  { name: "Huddersfield Town", league: "League One", color: "#0072CE" },
  { name: "Leyton Orient", league: "League One", color: "#DE0000" },
  { name: "Lincoln City", league: "League One", color: "#EE2737" },
  { name: "Luton Town", league: "League One", color: "#F04E23" },
  { name: "Mansfield Town", league: "League One", color: "#FFDF00" },
  { name: "Northampton Town", league: "League One", color: "#8B1F3D" },
  { name: "Peterborough United", league: "League One", color: "#004990" },
  { name: "Plymouth Argyle", league: "League One", color: "#00553F" },
  { name: "Port Vale", league: "League One", color: "#FFCD00" },
  { name: "Reading", league: "League One", color: "#004A98" },
  { name: "Rotherham United", league: "League One", color: "#DD1E1E" },
  { name: "Stevenage", league: "League One", color: "#E60023" },
  { name: "Stockport County", league: "League One", color: "#003A70" },
  { name: "Wigan Athletic", league: "League One", color: "#1D5BA4" },
  { name: "Wycombe Wanderers", league: "League One", color: "#003399" },

  // ---------- EFL League Two (2025/26) ----------
  { name: "Accrington Stanley", league: "League Two", color: "#D40000" },
  { name: "Barnet", league: "League Two", color: "#F58220" },
  { name: "Barrow", league: "League Two", color: "#003D7D" },
  { name: "Bristol Rovers", league: "League Two", color: "#0055A4" },
  { name: "Bromley", league: "League Two", color: "#FFFFFF" },
  { name: "Cambridge United", league: "League Two", color: "#F1C40F" },
  { name: "Cheltenham Town", league: "League Two", color: "#DA291C" },
  { name: "Chesterfield", league: "League Two", color: "#0033A0" },
  { name: "Colchester United", league: "League Two", color: "#003366" },
  { name: "Crawley Town", league: "League Two", color: "#E30613" },
  { name: "Crewe Alexandra", league: "League Two", color: "#E63946" },
  { name: "Fleetwood Town", league: "League Two", color: "#DA291C" },
  { name: "Gillingham", league: "League Two", color: "#005EB8" },
  { name: "Grimsby Town", league: "League Two", color: "#000000" },
  { name: "Harrogate Town", league: "League Two", color: "#F9DC00" },
  { name: "Milton Keynes Dons", league: "League Two", color: "#EF3E42" },
  { name: "Newport County", league: "League Two", color: "#F5A800" },
  { name: "Notts County", league: "League Two", color: "#000000" },
  { name: "Oldham Athletic", league: "League Two", color: "#0033A0" },
  { name: "Salford City", league: "League Two", color: "#DA291C" },
  { name: "Shrewsbury Town", league: "League Two", color: "#003C71" },
  { name: "Swindon Town", league: "League Two", color: "#DA291C" },
  { name: "Tranmere Rovers", league: "League Two", color: "#003C71" },
  { name: "Walsall", league: "League Two", color: "#DA291C" },

  // ---------- Vanarama National League (2025/26) ----------
  { name: "Aldershot Town", league: "National League", color: "#DA291C" },
  { name: "Altrincham", league: "National League", color: "#DA291C" },
  { name: "Boreham Wood", league: "National League", color: "#F58220" },
  { name: "Boston United", league: "National League", color: "#DA291C" },
  { name: "Brackley Town", league: "National League", color: "#DA291C" },
  { name: "Braintree Town", league: "National League", color: "#F58220" },
  { name: "Carlisle United", league: "National League", color: "#0033A0" },
  { name: "Eastleigh", league: "National League", color: "#003C71" },
  { name: "FC Halifax Town", league: "National League", color: "#0033A0" },
  { name: "Forest Green Rovers", league: "National League", color: "#0F4B2A" },
  { name: "Gateshead", league: "National League", color: "#000000" },
  { name: "Hartlepool United", league: "National League", color: "#005EB8" },
  { name: "Morecambe", league: "National League", color: "#DA291C" },
  { name: "Rochdale", league: "National League", color: "#003C71" },
  { name: "Scunthorpe United", league: "National League", color: "#8B1F3D" },
  { name: "Solihull Moors", league: "National League", color: "#F58220" },
  { name: "Southend United", league: "National League", color: "#0033A0" },
  { name: "Sutton United", league: "National League", color: "#F1C40F" },
  { name: "Tamworth", league: "National League", color: "#DA291C" },
  { name: "Truro City", league: "National League", color: "#000000" },
  { name: "Wealdstone", league: "National League", color: "#00306B" },
  { name: "Woking", league: "National League", color: "#DA291C" },
  { name: "Yeovil Town", league: "National League", color: "#00A54F" },
  { name: "York City", league: "National League", color: "#DA291C" },

  // ---------- National League North (2025/26) ----------
  { name: "AFC Fylde", league: "National League North", color: "#DA291C" },
  { name: "AFC Telford United", league: "National League North", color: "#FFFFFF" },
  { name: "Alfreton Town", league: "National League North", color: "#DA291C" },
  { name: "Bedford Town", league: "National League North", color: "#003C71" },
  { name: "Buxton", league: "National League North", color: "#003C71" },
  { name: "Chester FC", league: "National League North", color: "#003C71" },
  { name: "Chorley", league: "National League North", color: "#000000" },
  { name: "Curzon Ashton", league: "National League North", color: "#003C71" },
  { name: "Darlington", league: "National League North", color: "#000000" },
  { name: "Hereford", league: "National League North", color: "#000000" },
  { name: "Kidderminster Harriers", league: "National League North", color: "#DA291C" },
  { name: "King's Lynn Town", league: "National League North", color: "#003C71" },
  { name: "Leamington", league: "National League North", color: "#F1C40F" },
  { name: "Macclesfield", league: "National League North", color: "#003C71" },
  { name: "Marine", league: "National League North", color: "#FFFFFF" },
  { name: "Merthyr Town", league: "National League North", color: "#F1C40F" },
  { name: "Oxford City", league: "National League North", color: "#003C71" },
  { name: "Peterborough Sports", league: "National League North", color: "#F1C40F" },
  { name: "Radcliffe", league: "National League North", color: "#003C71" },
  { name: "Scarborough Athletic", league: "National League North", color: "#DA291C" },
  { name: "South Shields", league: "National League North", color: "#DA291C" },
  { name: "Southport", league: "National League North", color: "#F1C40F" },
  { name: "Spennymoor Town", league: "National League North", color: "#000000" },
  { name: "Worksop Town", league: "National League North", color: "#F1C40F" },

  // ---------- National League South (2025/26) ----------
  { name: "AFC Totton", league: "National League South", color: "#F58220" },
  { name: "Chelmsford City", league: "National League South", color: "#003C71" },
  { name: "Chesham United", league: "National League South", color: "#003C71" },
  { name: "Dagenham & Redbridge", league: "National League South", color: "#003C71" },
  { name: "Dorking Wanderers", league: "National League South", color: "#F1C40F" },
  { name: "Dover Athletic", league: "National League South", color: "#FFFFFF" },
  { name: "Ebbsfleet United", league: "National League South", color: "#DA291C" },
  { name: "Farnborough", league: "National League South", color: "#DA291C" },
  { name: "Hampton & Richmond Borough", league: "National League South", color: "#003C71" },
  { name: "Hemel Hempstead Town", league: "National League South", color: "#F58220" },
  { name: "Hornchurch", league: "National League South", color: "#DA291C" },
  { name: "Horsham", league: "National League South", color: "#F58220" },
  { name: "Maidenhead United", league: "National League South", color: "#000000" },
  { name: "Maidstone United", league: "National League South", color: "#F1C40F" },
  { name: "Salisbury", league: "National League South", color: "#FFFFFF" },
  { name: "Slough Town", league: "National League South", color: "#F1C40F" },
  { name: "Tonbridge Angels", league: "National League South", color: "#003C71" },
  { name: "Torquay United", league: "National League South", color: "#F1C40F" },
  { name: "Weston-super-Mare", league: "National League South", color: "#003C71" },
  { name: "Worthing", league: "National League South", color: "#DA291C" },

  // ---------- Scottish Premiership (kept from previous list) ----------
  { name: "Celtic", league: "Scottish Premiership", color: "#008C48" },
  { name: "Rangers", league: "Scottish Premiership", color: "#0033A0" },
  { name: "Hibernian", league: "Scottish Premiership", color: "#0E653A" },
  { name: "Heart of Midlothian", league: "Scottish Premiership", color: "#8B0028" },
  { name: "Aberdeen", league: "Scottish Premiership", color: "#E03A3E" },
];

export const RIVALRIES = {
  "Arsenal": ["Tottenham Hotspur", "Chelsea"],
  "Tottenham Hotspur": ["Arsenal", "Chelsea"],
  "Liverpool": ["Manchester United", "Everton"],
  "Everton": ["Liverpool"],
  "Manchester United": ["Manchester City", "Liverpool", "Leeds United"],
  "Manchester City": ["Manchester United"],
  "Chelsea": ["Arsenal", "Tottenham Hotspur"],
  "Newcastle United": ["Sunderland", "Middlesbrough"],
  "Sunderland": ["Newcastle United", "Middlesbrough"],
  "Aston Villa": ["Birmingham City", "West Bromwich Albion"],
  "Birmingham City": ["Aston Villa", "West Bromwich Albion"],
  "West Bromwich Albion": ["Aston Villa", "Wolverhampton Wanderers"],
  "Wolverhampton Wanderers": ["West Bromwich Albion"],
  "Leeds United": ["Manchester United"],
  "Celtic": ["Rangers"],
  "Rangers": ["Celtic"],
  "Sheffield United": ["Sheffield Wednesday"],
  "Sheffield Wednesday": ["Sheffield United"],
  "Nottingham Forest": ["Derby County", "Leicester City"],
  "Derby County": ["Nottingham Forest", "Leicester City"],
  "Leicester City": ["Nottingham Forest", "Derby County"],
  "Norwich City": ["Ipswich Town"],
  "Ipswich Town": ["Norwich City"],
  "Cardiff City": ["Swansea City"],
  "Swansea City": ["Cardiff City"],
  "Portsmouth": ["Southampton"],
  "Southampton": ["Portsmouth"],
  "Bristol City": ["Bristol Rovers"],
  "Bristol Rovers": ["Bristol City"],
  "Plymouth Argyle": ["Exeter City"],
  "Exeter City": ["Plymouth Argyle"],
  "Preston North End": ["Blackpool", "Blackburn Rovers"],
  "Blackpool": ["Preston North End"],
  "Blackburn Rovers": ["Burnley"],
  "Burnley": ["Blackburn Rovers"],
  "Hull City": ["Middlesbrough"],
  "Middlesbrough": ["Newcastle United", "Sunderland"],
  "Carlisle United": ["Newcastle United"],
  "Stoke City": ["Port Vale"],
  "Port Vale": ["Stoke City"],
  "Notts County": ["Nottingham Forest"],
};
